import eMuseumHttp from '../../httpServices/eMuseumHttpService'
import {
  MASTERPIECES_FAVORITES_OBJECTS,
  OBJECT_DETAIL,
} from '@lib/const/api-endpoints.const'
import { ISelectionsCollection } from '@interfaces'
import {
  createNavLink,
  getCurrentLocaleByObjectTitle,
  shuffleWithSeed,
} from '@utils'

type EMuseumFavoriteObject = {
  sourceId?: { value?: string }
  primaryMedia?: { value?: string }
  portfolio?: { value?: string }
  displayDate?: { value?: string }
  title?: { value?: string }
  restrictions?: { value?: string }
  people?: { value?: string }
}

type EMuseumFavoritesResponse = {
  objects?: EMuseumFavoriteObject[]
}

type EMuseumObjectDetail = {
  classification?: { value?: string }
  [key: string]: unknown
}

// Sabit seed: karışık görünür ama her yenilemede aynı sıra korunur.
const MASTERPIECES_HOME_SHUFFLE_SEED = 20260617

const getClassification = async (sourceId: string): Promise<string> => {
  try {
    const detail = (await eMuseumHttp.get(OBJECT_DETAIL(sourceId))) as {
      object?: EMuseumObjectDetail[]
    }
    return detail?.object?.[0]?.classification?.value ?? ''
  } catch {
    return ''
  }
}

export const SelectionsFromCollectionService = {
  /**
   * Ana sayfa için Koleksiyonlardan Seçmeler (eMuseum favorites listesi).
   * Her eserin koleksiyon adı obje detayından çekilir.
   */
  getSelectionsFromCollection: async (
    locale: string | 'en' | 'tr'
  ): Promise<ISelectionsCollection[]> => {
    const response = (await eMuseumHttp.get(
      MASTERPIECES_FAVORITES_OBJECTS
    )) as EMuseumFavoritesResponse

    const objects = response?.objects ?? []
    const collectionsUrl = createNavLink('collections', locale)

    const items = await Promise.all(
      objects.map(async (object) => {
        const sourceId = object?.sourceId?.value
        const portfolioId = object?.portfolio?.value
        const displayDate = object?.displayDate?.value || ''
        const classification = sourceId
          ? await getClassification(sourceId)
          : ''

        return {
          id: sourceId ? String(sourceId) : undefined,
          imgUrl: object?.primaryMedia?.value || '',
          title: getCurrentLocaleByObjectTitle(object, locale),
          artist: object?.people?.value || '',
          people: portfolioId ? String(portfolioId) : undefined,
          date: displayDate,
          name: classification,
          url: collectionsUrl,
        }
      })
    )

    return shuffleWithSeed(items, MASTERPIECES_HOME_SHUFFLE_SEED)
  },
}
